export default {
  haulers: 'Vilkikai',
  setup: 'Sąranka',
  driverExperience: 'Vairuotojo patirtis',
  users: 'Vartotojai',
};
